import React from 'react';
import PropTypes from 'prop-types';
import {Image} from '@learningblocks/shared-components';
import MoveIcon from '@common/images/move.svg';

/**
 * SlideThreeOption:
 *  - SlideThreeOption Component in dropped state.
 */
export function SlideThreeOption(props) {
  return (
    <div className='node-holder node-dropped'>
      <div
        className='node-dropped__image'
        style={{backgroundColor: props.groupColor}}>
        <Image src={MoveIcon} alt='move_icon' />
      </div>
      <div className='node-dropped__text'>
        <p>{props.text}</p>
        {props.children}
      </div>
      <div className='node-dropped__feedback'>{props.feedback}</div>
    </div>
  );
}

SlideThreeOption.propTypes = {
  /**
   * Component to display the feedback for the option
   */
  feedback: PropTypes.element.isRequired,
  /**
   * Unique Id of the dropped option
   */
  id: PropTypes.number.isRequired,
  /**
   * Text to dispaled on the option
   */
  text: PropTypes.string.isRequired,
  /**
   * Color hex value for the option
   */
  groupColor: PropTypes.string.isRequired,
  /**
   * Operational components displayed on Option
   * Eg: RemoveOptionIcon
   */
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.array]),
};

SlideThreeOption.defaultProps = {
  text: '',
  groupColor: '#ffffff',
};
